import loader from "@/assets/loader.svg";
interface LoaderProps {
  text?: string;
}

export default function Loader({ text }: LoaderProps) {
  return (
    <div className="flex items-center w-fit">
      <div className="animate-spin w-5 h-5 grid place-items-center">
        <img className="w-4 h-4" src={loader} />
      </div>
      {text && (
        <span className="ml-2 font-medium animate-swapin text-base leading-6 text-[#393939]">
          {text}
        </span>
      )}
    </div>
  );
}
